import { Typography, Box, makeStyles, Button, Theme } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BiDownload } from 'react-icons/bi'

interface IProps {
  children?: React.ReactNode
  countText?: string
  onExport?: () => void
  onReset?: () => void
  subtitle?: string
  title?: string
}

/* Template header for filter panel, with a title a counter and a reset button */
const FilterPanelHeader = (props: IProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Box display="flex" className={classes.root}>
      <Box display="flex" flexDirection="column" flex="1">
        <Box display="flex" alignItems="center">
          <Typography
            variant="h5"
            noWrap={true}
            className={classes.title}
            title={props.title ?? t('filtersPanel.title.default')}
          >
            {props.title ?? t('filtersPanel.title.default')}
          </Typography>
        </Box>

        {props.subtitle && (
          <Typography variant="h6" noWrap={true} title={props.subtitle}>
            {props.subtitle}
          </Typography>
        )}
        {props.countText && (
          <Typography display="inline" variant="subtitle2">
            {props.countText}
          </Typography>
        )}
      </Box>

      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {props.onReset && (
          // TODO: Create a proper component to replace the current one
          <Button variant="contained" disableElevation={true} className={classes.button} onClick={props.onReset}>
            {t('Reset filters')}
          </Button>
        )}

        {props.onExport && (
          // TODO: Create a proper component to replace the current one
          <Tooltip title={t('common.export') as string} placement="bottom" classes={{ tooltip: classes.tooltip }}>
            <IconButton className={classes.iconButton} onClick={props.onExport}>
              <BiDownload className={classes.exportIcon} />
            </IconButton>
          </Tooltip>
        )}
        {props.children}
      </div>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
  title: {
    marginBottom: 4,
  },
  button: {
    background: '#EBEDF3', //TODO: Set on theme
    color: '#000',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
    textTransform: 'none',
    opacity: 0.6,
  },
  exportIcon: {
    cursor: 'pointer',
  },
  iconButton: {
    background: '#ECF5FF',
    borderRadius: '4px',
    height: '28px',
    width: '28px',
    padding: 0,
    color: theme.palette.primary.main,
  },
  tooltip: {
    fontSize: 13,
  },
}))

export default FilterPanelHeader
